/*****************************************************************************
 *
 * Redux store creator. The exported configureStore method is used to create
 * the single global redux store used in index.js
 *
 *****************************************************************************/

import {createStore, applyMiddleware, compose} from 'redux';
import thunkMiddleware from 'redux-thunk';

import api from './api';
import reducer from './reducer';

const enhancers = [];

const middleware = [
  thunkMiddleware.withExtraArgument(api)
];

// Add devtools and redux logging in development
if (process.env.NODE_ENV === 'development') {
  const devToolsExtension = window.devToolsExtension;

  if (typeof devToolsExtension === 'function') {
    enhancers.push(devToolsExtension());
  }

  const {createLogger} = require(`redux-logger`);
  middleware.push(createLogger({collapsed: true}));
}

const composedEnhancers = compose(
  applyMiddleware(...middleware),
  ...enhancers
);

// Return a function for better control during tests
const configureStore = initialState => {
  return createStore(
    reducer,
    initialState,
    composedEnhancers
  );
};

export default configureStore;
